import { render, staticRenderFns } from "./ReferrerInformationView.vue?vue&type=template&id=20143cc7&"
import script from "./ReferrerInformationView.vue?vue&type=script&lang=ts&"
export * from "./ReferrerInformationView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports